const checkHasPromptCommands = (
    text: string,
): boolean => /\{\{\s*(#|\/|>?)\s*([\w.-]+)(?:\s+[^}]+?)?\s*\}\}/gi.test(text);

export default checkHasPromptCommands;
